import {Howl, Howler} from 'howler';


export default class CharaVoice{

    constructor(){
        this._init();
    }

    _init(){
        this.sound = null;
        this.current = null;

        [...document.querySelectorAll('.js-voice__item')].forEach($item=>{

            $item.addEventListener('click', ()=>{

                if($item.classList.contains('-playing')){
                    this.sound.stop();
                    this.current.classList.remove('-playing');
                    this.current = null;
                }
                else{
                    const file = $item.getAttribute('data-voice');
                    this._playSound(file);

                    if(this.current) this.current.classList.remove('-playing');
                    $item.classList.add('-playing');
                    this.current = $item;
                }
            });
        });
    }


    _playSound(file){
        if(this.sound) this.sound.stop();

        this.sound = new Howl({
            src: `${file}?${new Date().getTime()}`,
            volume: 0.65
        });

        this.sound.on('load',() => {
            this.sound.play();
        });

        this.sound.on('end',() => {
            this.current.classList.remove('-playing');
            this.current = null;
            this.sound = null;
        });
    }
}